import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Radio from '@catalogo/ui-americanas-desktop-product-review/src/legacy/components/radio';

const FilterInput = ({ filters, onChange, width, name, show, toggleFilter, stateRating }) => {
  const [selected, setSelected] = useState('');

  const onChangeField = (event, filteredItem) => {
    const filteredItemWithEventAction = { ...filteredItem, eventAction: 'Avaliações - Filtro' };
    const { value } = event.target;
    onChange(filteredItemWithEventAction);
    setSelected(value);
    toggleFilter(name);
  };

  useEffect(() => {
    setSelected(stateRating?.name);
  }, [stateRating]);

  const renderOptions = filters.map(filter => (
    <Radio
      key={filter.name}
      countReview={filter.countReview}
      label={filter.name}
      name={name}
      selected={selected}
      onChange={e => onChangeField(e, filter)}
    />
  ));

  useEffect(() => {
    const [defaultFilter] = filters;
    setSelected(defaultFilter.name);
  }, []);

  return (
    <>
      <Wrapper>
        <Button onClick={() => toggleFilter(name)} width={width} className={show ? 'active' : ''}>
          <span>{selected}</span>
        </Button>
      </Wrapper>
      <WrapperOptions display={show ? 'block' : 'none'}>{renderOptions}</WrapperOptions>
    </>
  );
};

export default FilterInput;

const Wrapper = styled.div`
  position: relative;
  flex: 1 0 calc(50% - 10px);
`;

const WrapperOptions = styled.div`
  position: absolute;
  background: white;
  box-shadow: 0px 1px 35px 4px rgba(0, 0, 0, 0.15);
  width: 100%;
  right: 0;
  top: 70px;
  padding: 5px 10px;
  display: ${({ display }) => display};
  z-index: 10;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  height: 43px;
  background: #fff;
  border-radius: 8px;
  border: 1.5px solid #b5b5b5;
  padding-left: 15px;
  color: #636363;
  font-size: 15px;
  position: relative;
  outline: none;
  width: 100%;
  cursor: pointer;

  span {
    width: 70%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &::after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    border: solid #999;
    border-width: 0 2px 2px 0;
    right: 15px;
    top: calc(50% - 4px);
    transform: rotate(45deg);
    transition: transform 0.3s ease-in-out;
  }

  &.active {
    border: 1px solid #000;
    color: #000;

    &::after {
      transform: rotate(225deg);
      border-color: #000;
      top: calc(50% - 2px);
    }
  }
`;
